//************************************************************************ /
// EVENT THANK YOU NOTE CARD
// White card allowing the event owner to send thank you notes (via a link).
// Themed off the event-cta-card
//************************************************************************ /

import React from "react";
import { Card, Button } from "@dreambigger/design-system/src/components";
import { RightOutlined } from "@ant-design/icons";
import InspireAnalytics, {
  InspireAnalyticEvents,
} from "@dreambigger/shared/src/utils/inspire-analytics-helper";
import { useMixpanel, useGA, useSegment } from "@dreambigger/shared/src/hooks";

type eventDetailThankYou = {
  buttonPath: string;
  buttonTitle: string;
  title: string;
};

const EventThankYouCard = (eventDetailThankYou: eventDetailThankYou) => {
  // Load Analytics
  const mixpanel = useMixpanel();
  const segment = useSegment();
  const googleAnalytics = useGA();

  //Do not display card if lacking essential information
  if (!eventDetailThankYou || eventDetailThankYou.buttonPath === "") {
    return <></>;
  }
  // Destructure data and render.
  const { buttonPath, buttonTitle, title } = eventDetailThankYou;

  const handleClick = () => {
    // Track analytics of button click
    googleAnalytics.event({
      category: "Event Detail Page",
      action: `Thank You Note Click - Card ${window.location.href}`,
      label: `${buttonTitle} - ${buttonPath}`,
      value: 1,
    });
    InspireAnalytics.track({
      eventName: InspireAnalyticEvents.THANK_YOU_BUTTON_CLICK,
      properties: {
        "Thank You Button Title": buttonTitle,
      },
      mixpanel,
      segment,
    });
  };

  return (
    <Card
      style={{
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
        backgroundColor: "white",
      }}
      bodyStyle={{ padding: "26px 26px" }}
    >
      <div className="flex flex-column items-center">
        {/* Thank You Note Care Text */}
        <h4 className="tl fwb f-5 mb-5 lh-3">{title}</h4>
        {/* Button Link */}
        <a href={buttonPath} className="flex w-100">
          <Button
            className={`primary b-primary ttu primaryBkdWhiteTxt h-7 w-100`}
            style={{ border: "solid 2px", transition: "0.1s" }}
            onClick={handleClick}
          >
            <RightOutlined className="vh" /> <span>{buttonTitle}</span>{" "}
            <RightOutlined />
          </Button>
        </a>
      </div>
    </Card>
  );
};

export default EventThankYouCard;
